import { Link } from 'react-router-dom';

export default function WhatIsSection() {
  return (
    <section id="guide" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              Getting Started
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-6">
              What Is <strong className="font-heading font-normal text-primary-600">VigorBuy Spreadsheet</strong>?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              VigorBuy Spreadsheet is a meticulously organized product database that revolutionizes the way you discover and shop for products online. Instead of spending hours searching through countless listings, you get instant access to curated collections sorted by category, complete with product details, pricing, and QC photos.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              The spreadsheet format offers a structured approach to product discovery — every item is tagged, categorized, and verified, so you can compare options side by side without jumping between multiple browser tabs. Whether you are hunting for sneakers, fashion pieces, or accessories, the spreadsheet streamlines your entire shopping journey.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              Unlike traditional product searches that scatter information across dozens of pages, the spreadsheet method consolidates everything into one clean, filterable view. This approach has quickly become the preferred way for savvy shoppers to find hidden gems and stay ahead of trending products.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-background-200/70 overflow-hidden">
            <div className="p-5 md:p-6 border-b border-background-200/50">
              <h3 className="font-heading text-lg md:text-xl text-foreground-900">Search Method Comparison</h3>
            </div>
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/50 bg-background-50">
                  <th className="text-left px-5 md:px-6 py-3 text-xs md:text-sm font-semibold text-foreground-700">Feature</th>
                  <th className="text-left px-5 md:px-6 py-3 text-xs md:text-sm font-semibold text-foreground-500">Normal Search</th>
                  <th className="text-left px-5 md:px-6 py-3 text-xs md:text-sm font-semibold text-accent-700">Spreadsheet Method</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { feature: 'Finding Products', normal: 'Slow', spreadsheet: 'Fast' },
                  { feature: 'Organization', normal: 'Low', spreadsheet: 'High' },
                  { feature: 'Comparison', normal: 'Difficult', spreadsheet: 'Easy' },
                  { feature: 'Product Tracking', normal: 'Manual', spreadsheet: 'Organized' },
                  { feature: 'Price Comparison', normal: 'Scattered', spreadsheet: 'Side-by-Side' },
                  { feature: 'QC Photo Access', normal: 'Limited', spreadsheet: 'Built-in' },
                ].map((row) => (
                  <tr key={row.feature} className="border-b border-background-100 last:border-0 hover:bg-background-50/50 transition-colors">
                    <td className="px-5 md:px-6 py-3 text-xs md:text-sm font-medium text-foreground-800">{row.feature}</td>
                    <td className="px-5 md:px-6 py-3 text-xs md:text-sm text-foreground-500">{row.normal}</td>
                    <td className="px-5 md:px-6 py-3 text-xs md:text-sm font-medium text-accent-700">{row.spreadsheet}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/vigorbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white border border-background-300 rounded-full text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer"
          >
            Read Complete Guide <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}